<template>
  <el-dialog :visible.sync="dialogVisible" :show-close="false" append-to-body>
    <img
      class="close-img"
      @click="dialogVisible = false"
      src="@/assets/img/images/icon/close-icon.png"
    />
    <p class="p1">{{ title }}</p>
    <p class="p2 mt20">
      {{ text }}
    </p>
    <div v-if="shouBtn" class="btn1">{{ btnText }}</div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "提示",
    },
    shouBtn: {
      type: Boolean,
      default: false,
    },
    btnText: {
      type: String,
      default: "立即邀请",
    },
  },
  data() {
    return {
      dialogVisible: false,
    };
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="less" scoped>
/deep/.el-dialog {
  width: 300px !important;
  background: #ffffff;
  border-radius: 10px 10px 10px 10px;
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    padding: 32px 30px;
  }
}
.p1 {
  text-align: center;
  font-family: PingFang SC, PingFang SC;
  font-weight: bold;
  font-size: 16px;
  color: #1f2329;
}
.p2 {
  text-align: center;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #1f2329;
}
.close-img {
  width: 14px;
  height: 14px;
  top: 20px;
  right: 20px;
  cursor: pointer;
  position: absolute;
}
.btn1 {
  width: 100%;
  height: 48px;
  cursor: pointer;
  margin-top: 32px;
  background: var(--primary-color);
  border-radius: 8px 8px 8px 8px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 20px;
  color: #ffffff;
  text-align: center;
  line-height: 48px;
}
</style>
